import { render, staticRenderFns } from "./x-form-submit.vue?vue&type=template&id=2b99a463&scoped=true&"
import script from "./x-form-submit.vue?vue&type=script&lang=js&"
export * from "./x-form-submit.vue?vue&type=script&lang=js&"
import style0 from "./x-form-submit.vue?vue&type=style&index=0&id=2b99a463&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99a463",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b99a463', component.options)
    } else {
      api.reload('2b99a463', component.options)
    }
    module.hot.accept("./x-form-submit.vue?vue&type=template&id=2b99a463&scoped=true&", function () {
      api.rerender('2b99a463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-form-submit.vue"
export default component.exports